import { render, staticRenderFns } from "./DeviceOsStats.vue?vue&type=template&id=5241be4a&scoped=true&"
import script from "./DeviceOsStats.vue?vue&type=script&lang=js&"
export * from "./DeviceOsStats.vue?vue&type=script&lang=js&"
import style0 from "./DeviceOsStats.vue?vue&type=style&index=0&id=5241be4a&prod&lang=scss&"
import style1 from "./DeviceOsStats.vue?vue&type=style&index=1&id=5241be4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5241be4a",
  null
  
)

export default component.exports